(function () {

  // ============================================
  // CALCULATORS
  // ============================================

  const calculators = {

    chemicals: function (inputs) {
      const vol = inputs.largo * inputs.ancho * inputs.profundidad * 1000; // litros
      const chlorineTypes = {
        granular90: { name: 'cloro granulado 90%', factor: 0.1, price: 290 },
        tablets200: { name: 'pastillas 200g',      factor: 0.12, price: 320 },
        liquid13:   { name: 'cloro líquido 13%',   factor: 0.8,  price: 180 }
      };
      const usageMultipliers = {
        residential_low:  0.8,
        residential_high: 1.0,
        commercial:       1.5
      };
      const freqMultipliers = {
        weekly:    1,
        every3:    0.45,
        daily:     0.15
      };

      const chlorine = chlorineTypes[inputs.chlorineType] || chlorineTypes.granular90;
      const usage    = usageMultipliers[inputs.usage] || 1;
      const freq     = freqMultipliers[inputs.frequency] || 1;

      const grams    = Math.round(vol * chlorine.factor * usage * freq);
      const kg       = (grams / 1000).toFixed(2);
      const price    = Math.round((grams / 1000) * chlorine.price);

      const freqLabels = { weekly: 'semanal', every3: 'cada 3 días', daily: 'diaria' };
      const freqLabel  = freqLabels[inputs.frequency] || 'semanal';

      return {
        meta:   'Volumen: ' + vol.toLocaleString('es-MX') + ' L · Dosis ' + freqLabel + ' recomendada',
        value:  grams.toLocaleString('es-MX') + ' g de ' + chlorine.name,
        detail: 'Equivalente a ~' + kg + ' kg',// · Precio estimado: $' + price.toLocaleString('es-MX') + ' MXN',
        btnLabel: 'Ver químicos recomendados'
      };
    },

    pump: function (inputs) {
      const vol = inputs.largo * inputs.ancho * inputs.profundidad * 1000;
      const recircs = parseFloat(inputs.recirculations) || 2;
      const hours   = parseFloat(inputs.hours) || 8;

      const flowLPH    = (vol * recircs) / hours;
      const flowM3H    = flowLPH / 1000;
      const headM      = parseFloat(inputs.head) || 10;

      // HP = (flow m3/h * head m) / (270 * efficiency)
      const efficiency = 0.7;
      const hpRaw      = (flowM3H * headM) / (270 * efficiency);
      const hp         = hpRaw <= 0.75 ? 0.75
                       : hpRaw <= 1    ? 1
                       : hpRaw <= 1.5  ? 1.5
                       : hpRaw <= 2    ? 2
                       : hpRaw <= 3    ? 3
                       : 5;

      return {
        meta:   'Volumen: ' + vol.toLocaleString('es-MX') + ' L · Flujo requerido: ' + Math.round(flowLPH).toLocaleString('es-MX') + ' L/h',
        value:  'Bomba de ' + hp + ' HP recomendada',
        detail: 'Caudal: ' + flowM3H.toFixed(1) + ' m³/h · ' + recircs + ' recirculaciones en ' + hours + ' h',
        btnLabel: 'Ver bombas recomendadas'
      };
    },

    filtration: function (inputs) {
      const vol      = inputs.largo * inputs.ancho * inputs.profundidad * 1000;
      const flowLPH  = vol / (parseFloat(inputs.hours) || 8);
      const flowM3H  = flowLPH / 1000;

      const filterTypes = {
        sand:       { name: 'filtro de arena', flowRate: 40 },
        cartridge:  { name: 'filtro de cartucho', flowRate: 30 },
        diatomite:  { name: 'filtro de tierra diatomácea', flowRate: 25 }
      };

      const filter   = filterTypes[inputs.filterType] || filterTypes.sand;
      const areaM2   = flowM3H / filter.flowRate;
      const diameter = Math.ceil(Math.sqrt((areaM2 / Math.PI)) * 2 * 100);

      const size = diameter <= 40  ? '40 cm (16")'
                 : diameter <= 50  ? '50 cm (20")'
                 : diameter <= 60  ? '60 cm (24")'
                 : diameter <= 76  ? '76 cm (30")'
                 : '91 cm (36")';

      return {
        meta:   'Volumen: ' + vol.toLocaleString('es-MX') + ' L · Flujo: ' + flowM3H.toFixed(1) + ' m³/h',
        value:  size + ' — ' + filter.name,
        detail: 'Área de filtración requerida: ' + areaM2.toFixed(2) + ' m²',
        btnLabel: 'Ver sistemas de filtración'
      };
    }
  };

  // ============================================
  // DOM
  // ============================================

  const section = document.querySelector('.pool-calc');
  if (!section) return;

  const typeBtns    = section.querySelectorAll('.pool-calc__type-btn');
  const panels      = section.querySelectorAll('.pool-calc__panel');
  const resultEl    = section.querySelector('.pool-calc__result');
  const resultMeta  = section.querySelector('.pool-calc__result-meta');
  const resultValue = section.querySelector('.pool-calc__result-value');
  const resultDetail = section.querySelector('.pool-calc__result-detail');
  const resultBtn   = section.querySelector('.pool-calc__result-btn');

  let activeType = 'chemicals';

  // Switch calculator type
  typeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      activeType = btn.dataset.type;

      typeBtns.forEach(function (b) { b.classList.remove('pool-calc__type-btn--active'); });
      btn.classList.add('pool-calc__type-btn--active');

      panels.forEach(function (p) { p.hidden = true; });
      const activePanel = section.querySelector('.pool-calc__panel[data-type="' + activeType + '"]');
      if (activePanel) activePanel.hidden = false;

      if (resultEl) resultEl.classList.remove('is-visible');
      calculate();
    });
  });

  // Spinner buttons
  section.querySelectorAll('.pool-calc__spinner-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = btn.closest('.pool-calc__input-wrap').querySelector('.pool-calc__input');
      const step  = parseFloat(input.dataset.step || 1);
      const min   = parseFloat(input.min || 0);
      const max   = parseFloat(input.max || 999);
      let val     = parseFloat(input.value) || 0;

      if (btn.dataset.dir === 'up')   val = Math.min(val + step, max);
      if (btn.dataset.dir === 'down') val = Math.max(val - step, min);

      input.value = parseFloat(val.toFixed(2));
      calculate();
    });
  });

  // Live recalculation on any input change
  section.querySelectorAll('.pool-calc__input, .pool-calc__select').forEach(function (el) {
    el.addEventListener('input', calculate);
    el.addEventListener('change', calculate);
  });

  // Collect inputs from active panel
  function getInputs() {
    const panel  = section.querySelector('.pool-calc__panel[data-type="' + activeType + '"]');
    if (!panel) return {};
    const inputs = {};
    panel.querySelectorAll('[data-key]').forEach(function (el) {
      const key = el.dataset.key;
      inputs[key] = isNaN(el.value) ? el.value : parseFloat(el.value) || 0;
    });
    return inputs;
  }

  function calculate() {
    const inputs = getInputs();
    const fn     = calculators[activeType];
    if (!fn) return;

    // Need at least volume > 0
    if ((inputs.largo || 0) <= 0 || (inputs.ancho || 0) <= 0 || (inputs.profundidad || 0) <= 0) {
      if (resultEl) resultEl.classList.remove('is-visible');
      return;
    }

    const result = fn(inputs);

    if (resultMeta)   resultMeta.textContent   = result.meta;
    if (resultValue)  resultValue.textContent  = result.value;
    if (resultDetail) resultDetail.textContent = result.detail;

    if (resultBtn) {
      const url = resultBtn.dataset[activeType + 'Url'] || resultBtn.dataset.url || '#';
      resultBtn.href = url;
      resultBtn.textContent = '';
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.innerHTML = '<line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/>';
      resultBtn.appendChild(svg);
      resultBtn.appendChild(document.createTextNode(' ' + result.btnLabel));
    }

    if (resultEl) resultEl.classList.add('is-visible');
  }

  // Init
  calculate();

})();